import { BorderColor, TagColor } from '../interface/common';

export enum ICustomerType {
  COMPANY = 'company',
  PRIVATE_PERSON = 'privateperson',
}
export enum CustomerSections {
  general = 'general',
  matters = 'matters',
  matterRequests = 'matterRequests',
  conflictChecks = 'conflictChecks',
  notes = 'notes',
}
export const cardBorderColorMapping: {
  [key in ICustomerType]: string;
} = {
  [ICustomerType.COMPANY]: BorderColor.GREEN,
  [ICustomerType.PRIVATE_PERSON]: BorderColor.BEIGE,
};
export const tagColorMapping: {
  [key in ICustomerType]: TagColor;
} = {
  [ICustomerType.COMPANY]: TagColor.GREEN,
  [ICustomerType.PRIVATE_PERSON]: TagColor.BEIGE,
};
